export default __webpack_public_path__ + "static/media/gallery_07.e2e782cf.jpg";